<template>
  <div class="RouterFooter">
    <div class="flower3"><img src="@/assets/house.png" alt=""></div>
    <div class="flower2"><img src="@/assets/house1.png" alt=""></div>
    <div class="box">
       <div class="box-left">
           <div class="img">
               <div>Contattaci</div>
               <div>Contact Us</div>
               <div class="line">
                 <div></div>
                 <div></div>
                 <div></div>
               </div>
           </div>
           <div class="content1" v-if="lan=='en'">
             <img src="@/assets/icon1.png" alt="">
             Suite C2, 12th Floor, Xinda Mansion, 1399 Beijing <br> West Rd, Jing’an District, 200040 Shanghai, PRC.
           </div>
           <div class="content1" v-else>
             <img src="@/assets/icon1.png" alt="">
             上海市静安区北京西路1399号 <br> 信达大厦12楼C2室 邮编：200040
           </div>
           <div class="content" v-if="detail" @click="callPhone(detail.phone)">
             <img src="@/assets/icon2.png" alt="">
             {{detail.phone}}
           </div>
           <div class="content">
             <img src="@/assets/icon3.png" alt="">
               office.assistant@amorewine.cn
           </div>
       </div>
       <div class="box-center" v-if="lan=='en'">
           <div class="img">

           </div>
           <div class="content" @click="back('/AboutUs',1)">
             <div class="none"></div>
             About Us
           </div>
           <div class="content" @click="back('/WineCulture',2)">
             <div class="none"></div>
             Brand Culture
           </div>
           <div class="content" @click="back('/ProductList',3)">
             <div class="none"></div>
            Product Introduction
           </div>
           <div class="content" @click="back('/InformationList',4)">
             <div class="none"></div>
             Wine Information
           </div>
           <div class="content" @click="back('/WineryList',5)">
             <div class="none"></div>
             Winery Culture
           </div>
           <div class="content" @click="back('/PromotionCooperation',6)">
             <div class="none"></div>
             Promotion Cooperation
           </div>
       </div>
       <div class="box-center1" v-else>
           <div class="img">

           </div>
           <div class="content1" @click="back('/AboutUs',1)">
             <div class="none"></div>
             关于爱醇
           </div>
           <div class="content1" @click="back('/WineCulture',2)">
             <div class="none"></div>
             葡萄酒文化
           </div>
           <div class="content1" @click="back('/ProductList',3)">
             <div class="none"></div>
            爱醇产品
           </div>
           <div class="content1" @click="back('/InformationList',4)">
             <div class="none"></div>
             美酒资讯
           </div>
           <div class="content1" @click="back('/WineryList',5)">
             <div class="none"></div>
             酒庄文化
           </div>
           <div class="content1" @click="back('/PromotionCooperation',6)">
             <div class="none"></div>
             推广合作
           </div>
       </div>
       <div class="box-right">
            <div class="img">
                 <img src="@/assets/logo.png" alt="">
            </div>
            <div class="er-img">
              <img src="@/assets/TwoDimensionalCode.jpg" @click="back1()" alt="">
              <img src="@/assets/code.jpg" @click="back2()"  alt="">
            </div>
            <div class="content">
              {{lan=="en" ? 'Follow the official account to learn more' : '关注公众号关于爱醇'}}
            </div>
       </div>
    </div>
    <div class="FooterLine"></div>
    <div class="ICP" @click="GoICP()">© 爱醇贸易（上海）有限公司 Copyright 2023 amorewine.cn All rights reserved. 沪ICP备08111328号-1</div>
    <div class="showswiperbox" v-model="showswiper"  :class="{ showswiper: showswiper }">
      <div>
        <img src="@/assets/out.png" alt="" @click="showswiper = false" />
      </div>
      <div>
        <img src="@/assets/TwoDimensionalCode.jpg" alt="">
      </div>
    </div>
    <div class="showswiperbox" v-model="showswiper1"  :class="{ showswiper: showswiper1 }">
      <div>
        <img src="@/assets/out.png" alt="" @click="showswiper1 = false" />
      </div>
      <div>
        <img src="@/assets/code.jpg" alt="">
      </div>
    </div>
   <a href="" v-show="false" ref="tels"></a>
  </div>
</template>

<script>
export default {
    props: {
      lan: String
    },
    data() {
      return {
        showswiper:false,
        showswiper1:false,
        detail:''
      }
    },
    mounted() {
      this.seo()
    },
    methods: {
      callPhone (phoneNumber) {
       this.$refs.tels.href = `tel://`+phoneNumber
        this.$refs.tels.click()
      },
      seo() {
        this.$http
        .post("/index/seo/list", {})
        .then((res) => {
          if (res.data.code == 0) {
            this.detail = res.data.data;
            console.log(res.data.data);
          }
        });
      },
      back1(){
        this.showswiper= true
      },
      back2(){
        this.showswiper1= true
      },
      back(i, idx) {
        this.n = idx
        this.$router.push(i);
        this.drawer = false
      },
        GoICP() {
            window.open("https://beian.miit.gov.cn/");
        }
    },
};
</script>

<style lang="scss" scoped>
.RouterFooter {
  background: #1e1e1e;
  padding: 97px 0 54px;
  @media (max-width: 1199px) {
   padding: 20px 0 4px;
  }
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  @keyframes swim {
  	0% {
  		width: 350px;
  	}
  	25%{
  		width: 375px;
  	}
  	50%{
  		width: 400px;
  	}
    75%{
    	width: 375px;
    }
  	100% {
  		width: 350px;
  	}
  }
  .flower3{
    width: 300px;
    height: auto;
    position: absolute;
    left: 0%;
    bottom: 0%;
    animation: swim 8s linear infinite;
    opacity: .3;
    @media (max-width: 1199px) {
      display: none;
    }
    img{
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  @keyframes swim1 {
  	0% {
  		width: 250px;
  	}
  	25%{
  		width: 275px;
  	}
  	50%{
  		width: 300px;
  	}
    75%{
    	width: 275px;
    }
  	100% {
  		width: 250px;
  	}
  }
  .flower2{
    width: 300px;
    height: auto;
    position: absolute;
    right: 20px;
    bottom: 0% !important;
    animation: swim1 10s linear infinite;
    opacity: .3;
    @media (max-width: 1199px) {
      display: none;
    }
    img{
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .box{
    width: 1300px;
    height: 300px;
    @media (max-width: 1499px) {
      width: 1200px;
    }
    @media (max-width: 1199px) {
      width: 100%;
      height: auto;
    }
    // background-color: white;
    color: white;
    margin: auto;
    display: flex;
    flex-wrap: wrap;
    .box-left{
      width: 40%;
      @media (max-width: 1199px) {
        width: 96%;
        margin-left: 2%;
      }
      height: 100%;

      .img{
        width: 200px;
        height: 110px;
        // background-color: red;
        margin-left: 50px;
        :first-child{
          font-size: 36px;
          font-weight: normal;
          color: #C5A176;
        }
        :nth-child(2){
          font-size: 26px;
          font-family: Playfair Display-Roman, Playfair Display;
          font-weight: normal;
          color: #FFFFFF;
        }
        .line {
          width: 100px;
          height: 4px;
          margin-top: 10px;
          display: flex;
          background-color: #F1F1F1;
          justify-content: space-between;

          :first-child {
            width: 33.33%;
            background-color: #009344;
          }

          :last-child {
            width: 33.33%;
            background-color: #EE3D42;
          }
        }
      }
      .content1{
        display: flex;
        height: 50px;
        line-height: 25px;
        margin-top: 25px;
        font-size: 14px;
        font-family: Source Han Sans SC-ExtraLight, Source Han Sans SC;
        img{
          width: 30px ;
          height: 30px ;
          margin-right: 10px;
          @media (max-width: 1199px) {
            width: 20px ;
            height: 20px ;
            margin-top: 5px;
          }
        }
      }
      .content{
        display: flex;
        height: 30px;
        line-height: 30px;
        margin-top: 20px;
        font-size: 14px;
        font-family: Source Han Sans SC-ExtraLight, Source Han Sans SC;
        cursor: pointer;
        a{
          color: white;
          cursor: pointer;
        }
        img{
          width: 30px ;
          height: 30px ;
          margin-right: 10px;
          @media (max-width: 1199px) {
            width: 20px ;
            height: 20px ;
            margin-top: 5px;
          }
        }
      }
    }
    .box-center{
      width: 35%;
      @media (max-width: 1199px) {
        width: 80%;
        margin-left: 10%;
        margin-top: 20px;
      }
      height: 100%;
      .img{
        width: 200px;
        height: 0px;
        margin: auto;
        // background-color: red;
      }
      .content{
        display: flex;
        height: 50px;
        line-height: 50px;
        font-size: 20px;
        font-family: Source Han Serif CN-Regular, Source Han Serif CN;
        cursor: pointer;
        .none{
          width: 8px;
          height: 8px;
          background: #C5A176;
          border-radius: 8px;
          margin-top: 21px;
          margin-right: 10px;
        }
        img{
          width: 30px ;
          height: 30px ;
        }
      }
      .content:hover{
        color: #C5A176;
      }
    }
    .box-center1{
      width: 35%;
      @media (max-width: 1199px) {
        width: 80%;
        margin-left: 10%;
        margin-top: 20px;
        display: flex;
        flex-wrap: wrap;
      }
      height: 100%;
      .img{
        width: 200px;
        height: 0px;
        margin: auto;
        // background-color: red;
      }
      .content1{
        width: 100%;
        @media (max-width: 1199px) {
          width: 50%;
          // justify-content: center;
        }
        display: flex;
        height: 50px;
        line-height: 50px;
        font-size: 16px;
        font-family: Source Han Serif CN-Regular, Source Han Serif CN;
        cursor: pointer;
        .none{
          width: 8px;
          height: 8px;
          background: #C5A176;
          border-radius: 8px;
          margin-top: 21px;
          margin-right: 10px;
        }
        img{
          width: 30px ;
          height: 30px ;
        }
      }
      .content1:hover{
        color: #C5A176;
      }
    }
    .box-right{
      width: 25%;
      @media (max-width: 1199px) {
        width: 100%;
        margin-top: 30px;
      }
      height: 100%;
      .img{
        width: auto;
        height: 110px;
        @media (max-width: 1199px) {
          height: auto;
        }
        // background-color: red;
        margin: auto;
        img{
          margin: auto;
          @media (max-width: 1199px) {
            width: 120px;
          }
        }
      }
      .er-img{
        width: 220px;
        height: 100px;
        margin: auto;
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
        cursor: pointer;
        img{
          width: 100px;
          height: 100px;
        }
      }
      .content{
        margin-top: 20px;
        @media (max-width: 1199px) {
          margin-top: 30px;
        }
        text-align: center;
      }
    }
  }
  .FooterLine{
    width: 100%;
    height: 2px;
    @media (max-width: 1199px) {
      margin-bottom: 13px;
      margin-top: 20px;
      height: 1px;
    }
    // background: #A31C1C;
    margin-bottom: 53px;
  }
  .ICP{
    @media (max-width: 1199px) {
      width: 90%;
      margin: auto;
      text-align: center;
      margin-bottom: 10px;
    }
    font-size: 14px;
    color: #FFFFFF;
    opacity: .7;
    cursor: pointer;
  }
  .showswiper {
    opacity: 1 !important;
    z-index: 9999999 !important;
  }
  .showswiperbox{
    transition: all 0.3s linear;
    cursor: pointer;
    opacity: 0;
    z-index: -1;
    position: fixed;
    // line-height: 2;
    width: 50%;
    height: 70%;
    top: 15%;
    left: 25%;
    padding: 0px 40px;
    @media (max-width: 1499px) {
      height: 78%;
      top: 20%;
      line-height: 1.5;
    }
    @media (max-width: 1199px) {
      display: none;
    }
    background-color: #1e1e1e;
    background-color: rgba(30, 30, 30, .8);
    color: white;
    // text-align: center;
    line-height: 2;
    overflow: auto;
    div{
      line-height: 2;
    }
    > :first-child {
      display: flex;
      justify-content: flex-end;

      img {
        // border: 5px solid #1e1e1e;
        width: 30px !important;
        // background: #1e1e1e;
        border-radius: 30px;
        height: 30px !important;
        text-align: right;
        margin-top: 5px;
        margin-right: 5px;
      }

      margin-bottom: 0px;
    }
    :nth-child(2){
      width: 400px;
      height: 400px;
      // background-color: #009344;
      margin: auto;
      margin-top: 105px;
      @media (max-width: 1499px) {
        margin-top: 10px;
      }
      img{
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RouterFooter.vue